import {
  OrganizationResponse,
  OrganizationSize,
  PersonalConsultant,
} from '../../../../core/clients/omni-core/models';
import { getFileUrl } from '../../../organizations/pipes/organization-file-url-pipe';
import { CreateOrganizationPayload } from '../../../organizations/store/organizations.store';

export interface OrganizationFormData {
  name: string;
  industry: string;
  size: OrganizationSize | '';
  profilePicture: File | { url: string } | null;
  personalConsultant: PersonalConsultant;
  hasDifferentLegalName: boolean;
  legalName: string;
}

export const toModel = (
  organization: OrganizationResponse | null | undefined,
): OrganizationFormData => ({
  name: organization?.name || '',
  industry: organization?.industry || '',
  size: organization?.size || '',
  profilePicture: organization?.profilePicture
    ? { url: getFileUrl(organization.profilePicture.id, organization.id) }
    : null,
  personalConsultant: organization?.personalConsultant ?? 'SIMON_ZOELLER',
  hasDifferentLegalName: !!organization?.legalName,
  legalName: organization?.legalName ?? '',
});

export const toPayload = (formData: OrganizationFormData): Partial<CreateOrganizationPayload> => ({
  name: formData.name || undefined,
  industry: formData.industry || undefined,
  size: formData.size || undefined,
  personalConsultant: formData.personalConsultant || undefined,
  file: formData.profilePicture instanceof File ? formData.profilePicture : undefined,
  legalName: formData.hasDifferentLegalName ? formData.legalName : '',
});
